import { forwardRef, useContext, useEffect, useRef, useState } from 'react';
import mergeRefs from 'merge-refs';

import { convertRemToPixels } from '@/common/lib/convertRemtoPx';
import { getCssVar } from '@/common/lib/cssVar';

import { IntroContext } from '../context';

import { calcAdapteStyles, hightlightComponentStyles } from './config';

const SvgAnimation = forwardRef<SVGRectElement>((_, ref) => {
  const [totalLength, setTotalLength] = useState(0);
  const svgRef = useRef<SVGRectElement | null>(null);
  const { highlightComponentRect, activeStep } = useContext(IntroContext);

  const strokeWidth = (totalLength * 20) / 100;

  useEffect(() => {
    if (svgRef.current) {
      const totalLength = svgRef.current.getTotalLength();
      setTotalLength(totalLength);
      svgRef.current.animate(
        [{ strokeDashoffset: 0 }, { strokeDashoffset: totalLength }],
        {
          duration: 4000,
          iterations: Infinity,
        },
      );
    }
  }, []);

  const desktopContainerOffsetLeft = parseFloat(
    getCssVar('--desktop-container-offset-left'),
  );

  const rectStyles =
    activeStep in hightlightComponentStyles
      ? calcAdapteStyles(hightlightComponentStyles[activeStep])
      : { padding: 0, rounded: convertRemToPixels(0.5) };

  return (
    !!highlightComponentRect && (
      <rect
        style={{
          // top: highlightComponentRect.top - highlightComponentRect.height,
          // left: highlightComponentRect.left,
          strokeDasharray: `${strokeWidth} ${totalLength - strokeWidth}`,
          transformOrigin: 'center',
        }}
        ref={mergeRefs(svgRef, ref)}
        rx={rectStyles.rounded}
        ry={rectStyles.rounded}
        x={
          highlightComponentRect.left -
          desktopContainerOffsetLeft -
          rectStyles.padding / 2 +
          (rectStyles.x || 0)
        }
        y={
          highlightComponentRect.top -
          rectStyles.padding / 2 +
          (rectStyles.y || 0)
        }
        className="element-border-animation pointer-events-none"
        height={highlightComponentRect.height + rectStyles.padding}
        width={highlightComponentRect.width + rectStyles.padding}
        // transform-origin="50% 50%"
        transform={rectStyles.rounded === '100%' ? 'scale(0.85)' : undefined}
        strokeLinejoin="round"
        fill="transparent"
      />
    )
  );
});

export { SvgAnimation };
